import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import HasOperatorsFilter from 'scoreboard/reports/common/filter/has-operators-filter'
import RangeSelector from 'scoreboard/components/calendar-range-selector'
import template from './period-range-date-filter.hbs'
import { renderPeriodIdsSelect }
	from 'scoreboard/datasets/filters/datasets-date-filter-step1'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

const PeriodRangeDateFilter = HasOperatorsFilter.extend({

	/**
	 * @param {Object} options.data the object holding the data for the filter
	 * @param {Object} options.allowedOperators hash of allowed operators, null for
	 * defaults
	 *
	 */
	initialize: function(options = {}) {
		options.allowedOperators = ['before', 'after', 'between-date-time', 'in-any-period']
		options.dataType = DATE
		options.operatorName ='dateTimeOperator'
		if (_.isNil(options.data.dateTimeOperator)) {
			options.data.dateTimeOperator = 'between-date-time'
		}

		HasOperatorsFilter.prototype.initialize.apply(this, arguments)

		let range = this.data.range
		if (_.isEmpty(range)) {
			range = null
		}
		this.rangeSelector = new RangeSelector({
			canChangeCalendar: true,
			range
		})
	},

	_renderAdditionalControls: function () {
		this.$el.append(template())
		this.rangeSelector.setElement(this.$('.toggler-rows')).render()
		return this
	},

	_onChangeOperator: function(e) {
		HasOperatorsFilter.prototype._onChangeOperator.apply(this, arguments)
		let operator = this._operatorSelect().val()
		let hideRangeSelector = operator == 'in-any-period'
		if (!hideRangeSelector) {
			let label = 'report.customReport.filter.trend.betweenThePeriods'
			if (operator == 'before') {
				this.rangeSelector.singlePeriod(true)
				label = 'report.customReport.massedit.before'
			} else if (operator == 'after') {
				this.rangeSelector.singlePeriod(true)
				label = 'report.customReport.massedit.after'
			} else {
				this.rangeSelector.singlePeriod(false)
			}
			this.$('.period-header-content').text(i18n.get(label))
		}
		this.$('in-any-periods-container').toggleClass('is-not-displayed', !hideRangeSelector)
		this.$('.range-selector-container').toggleClass('is-not-displayed', hideRangeSelector)
	},

	_renderValuesSelect: function() {
		//this view doesn't use the traditional value selector with suggestions
		//instead it uses the known calendar periods to build the dropdown
		this._valuesSelect().parent().addClass('is-not-displayed')
		renderPeriodIdsSelect(this._inAnyPeriodSelector(), this.data.periodIds)
		this.$('.in-any-periods-container').toggleClass('is-not-displayed', this._isHidingValues())
	},

	test: function() {
		if (!this._isHidingValues() && _.isEmpty(this._inAnyPeriodSelector().val())) {
			return i18n.get('datasets.filters.date.periods.required')
		}
		return null
	},

	_inAnyPeriodSelector: function() {
		return this.$('select[name=inAnyPeriodIds]')
	},

	gather: function(e) {
		//clear out the previous date data
		this.data = {
			dateTimeOperator: this._operatorSelect().val()
		}
		if (this._isHidingValues()) {
			this.data.range = this.rangeSelector.val()
		} else {
			this.data.periodIds = this._inAnyPeriodSelector().val()
		}
		return this.data
	},

	remove: function() {
		HasOperatorsFilter.prototype.remove.apply(this, arguments)
		this.rangeSelector.remove()
	}


})

export default PeriodRangeDateFilter

PeriodRangeDateFilter.__filename__ = 'reports/wizard/filter-meta/period-range-date-filter.js'
